export class ExchangeTokensError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ExchangeTokensError';
  }
}

export class LogoutFailedError extends Error {
  constructor(message: string = 'Неудачная попытка выхода') {
    super(message);
    this.name = 'LogoutFailedError';
  }
}

export function handleSessionErrors(error: unknown): void {
  if (error instanceof ExchangeTokensError) {
    console.error('Ошибка: не удалось получить токены.');
  } else {
    console.error('Произошла неизвестная ошибка.');
  }

  throw new Error();
}
